import { PegasusMustangClient } from '@/helpers/pegasusMustangClient';

export default class PostgradEarlyGraduationRequestService {
  static async getPostgradMinPeriodByCourseId({
    courseId,
  }: {
    courseId: number;
  }) {
    try {
      const minPeriodResponse = await PegasusMustangClient.request({
        method: 'GET',
        requestURL: `/early-graduation/min-period?courseId=${courseId}`,
      });

      return minPeriodResponse.data.data.minPeriod;
    } catch (err) {
      return null;
    }
  }
  static async updateMinPeriodByCourseId({
    courseId,
    minPeriod,
  }: {
    courseId: number;
    minPeriod: number;
  }) {
    return await PegasusMustangClient.request({
      method: 'PUT',
      requestURL: `/early-graduation/eligibility`,
      bodyData: {
        courseId,
        minPeriod,
      },
    });
  }
}
